import React from 'react';
import { Box, Skeleton } from '@mui/material';

/**
 * Full-page loading skeleton. Use inside Suspense fallbacks and initial data loads.
 * Props: rows — number of skeleton rows to render (default 4)
 */
const PageSkeleton = ({ rows = 4 }) => (
  <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
    <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 2 }} />
    {Array.from({ length: rows }).map((_, i) => (
      <Skeleton key={i} variant="rectangular" height={80} sx={{ borderRadius: 2 }} />
    ))}
  </Box>
);

export default PageSkeleton;
